export let data = {
  title: "Upload Form Surveilans",
  backBtn: "/operasi",
  actionBtn: [],
  breadcrumb: [
    { title: "Operasi", link: "/operasi" },
    { title: "Upload Form Surveilans", active: true }
  ]
};
export let today=new Date();
import {getTime} from './helper.js';
export let time=getTime(today.getHours(),today.getMinutes());
export let rightForm = [
  {
    colnum: 1,
    columns: [
      {
        label: "Upload/Ubah Form Surveilans",
        type: "file",
        placeholder: "",
        name: "file_surveilans",
        value: "",
        mandatory: false,
        optional:true
      }
    ]
  }
];